import gql from "graphql-tag";

export const PRODUCT_MEDIA_QUERY = gql`
  query ($handle: String!) {
    productByHandle(handle: $handle) {
      id
      handle
      tags
      title
      vendor
      product_type: metafield(namespace: "my_fields", key: "product_type") {
        key
        value
      }
      media(first: 3) {
        edges {
          node {
            mediaContentType
            alt
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
      }
      variants(first: 200) {
        edges {
          node {
            id
            title
            barcode
            product{
              tags,
              id
            }
            image {
              src
              height
              altText
              width
            }
            selectedOptions {
              name
              value
            }
            priceV2 {
              amount
            }
            compareAtPriceV2 {
              amount
            }
            selectedOptions {
              name
              value
            }
            availableForSale
            quantityAvailable
            hexColor: metafield(namespace: "color", key: "hexcolor") {
              key
              value
            }
            sku
            olivela_cost: metafield(namespace: "my_fields", key: "olivela_cost") {
              key
              value
            }
            local_item: metafield(namespace: "my_fields", key: "local_item") {
              key
              value
            }
            baseColor: metafield(namespace: "color", key: "base_color") {
              key
              value
            }
          }
        }
      }
      availableForSale
      options(first: 100) {
        id
        name
        values
      }
    }
  }
`;


export const PRODUCT_MEDIA_LITE_QUERY = gql`
  query ($handle: String!) {
    productByHandle(handle: $handle) {
      id
      handle
      tags
      title
      vendor
      product_type: metafield(namespace: "my_fields", key: "product_type") {
        key
        value
      }
      media(first: 2) {
        edges {
          node {
            mediaContentType
            alt
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
      }
      availableForSale
    }
  }
`;
